// extracted by mini-css-extract-plugin
export default {"wrapper":"CStarsRewardsDialog_wrapper_e0300","rewardsContainer":"CStarsRewardsDialog_rewardsContainer_fdfea"};